import React, { useEffect, useState } from "react";
import styles from "./header.module.css";
import logo from "../../assets/images/CatchUp_logo_navbar.svg";
import { Link, Redirect } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import cookie from "react-cookies";
import ReactCountryFlag from "react-country-flag";
import SelectLanguage from "../../containers/selectLanguage/selectedLanguage";
import GlobalLanguageSwitcher from "../GlobalLanguageSwitcher/GlobalLanguageSwitcher";
import { getLanguagePack, iesLogout } from "../../service/service";
import { QuestionMarkCircleIcon } from "../../assets/icons/QuestionMarkCircle";
import { ArrowRightStartOnRectangleIcon } from "../../assets/icons/ArrowRightStartOnRectangle";
import { ArrowUturnLeftIcon } from "../../assets/icons/ArrowUturnLeft";


// Feature flag: habilitar/desabilitar seletor de idioma dos enunciados no header
// Temporariamente desabilitado — reabilitar quando tradução de enunciados estiver estável
const FEATURE_LANGUAGE_SWITCHER_ENABLED = false;

const Header = (props) => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [modalOpen, setModalOpen] = useState(shouldOpenModal());
  const [languagePack, setLanguagePackage] = useState(getLanguagePack());
  const [menuOpenMobile, setMenuOpenMobile] = useState(false);

  function _getMessage(message) {
    return languagePack[message] ? languagePack[message] : message;
  }

  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);

  const handleLogout = async () => {
    const rawToken = localStorage.getItem("token_info_hint");
    const id_token_hint = rawToken ? rawToken.replace(/^"|"$/g, "") : null;

    cookie.remove("token_info", { path: "/" });
    localStorage.removeItem('languagePack');
    localStorage.removeItem('currentBookId');
    localStorage.removeItem('currentBookName');
    localStorage.removeItem('userFromIES');
    localStorage.removeItem('user-info');

    if (id_token_hint) {
        await iesLogout({ id_token_hint });
    }

    localStorage.removeItem('token_info_hint');

    setLoggedIn(false);
};

  function getLanguageFlag(code) {
    switch (code) {
      case "en":
        return "us";
      case "pt":
        return "br";
      default:
        return code;
    }
  }

  function shouldOpenModal() {
    const user = JSON.parse(localStorage.getItem("user-info")) || {
      data: { available_languages: [] },
    };
    const language = JSON.parse(localStorage.getItem("languagePack")) || {};

    if (
      !language.selectedLanguage &&
      user.data.available_languages.length > 1
    ) {
      return true;
    } else {
      return false;
    }
  }

  if (!loggedIn) {
    return <Redirect to={{ pathname: "/" }} />;
  }

  const language = JSON.parse(localStorage.getItem("languagePack")) || {};

  return (
    <header className={styles.header}>
      {modalOpen && <SelectLanguage closeModal={closeModal} />}
      <nav className={styles.container}>
        <div className={styles.content_country_flag}>
          {props.menuLanguage && (
            <button
              className={`${styles.button} ${styles.button_country_flag}`}
              onClick={openModal}
            >
              <ReactCountryFlag
                svg
                className={styles.country_flag}
                countryCode={getLanguageFlag(language.selectedLanguage)}
              />
              <span>Change course</span>
            </button>
          )}
          {props.exercise && (
            <Link className={styles.button} to={`/classes/list`}>
              <ArrowUturnLeftIcon className={styles.icon} />
              Back
            </Link>
          )}
        </div>
        <div>
          <h1>
            <Link to="/classes/list">
              <img className={styles.logo} src={logo} alt="Logo Catch Up" />
            </Link>
          </h1>
        </div>
        <div className={styles.options}>
          {FEATURE_LANGUAGE_SWITCHER_ENABLED && <GlobalLanguageSwitcher />}
          <a
            className={`${styles.button} ${styles.button_question}`}
            href="https://franquias.wizard.com.br/wiz-tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            <QuestionMarkCircleIcon className={styles.icon} />
            <span>FAQ</span>
          </a>
          <button
            className={`${styles.button} ${styles.button_logout}`}
            onClick={handleLogout}
          >
            <ArrowRightStartOnRectangleIcon className={styles.icon} />
            <span>Logout</span>
          </button>
          <button
            className={`${styles.button} ${styles.menu_hamburguer}`}
            onClick={() => setMenuOpenMobile(!menuOpenMobile)}
          >
            <FontAwesomeIcon icon={faBars} />
            {/* <Bars3BottomRightIcon className={styles.icon} /> */}
          </button>
          <div className={styles.dropdown}>
            {menuOpenMobile && (
              <div className={styles.dropdownContent}>
                <a
                  onClick={() => {
                    openModal();
                    setMenuOpenMobile(!menuOpenMobile);
                  }}
                >
                  <ReactCountryFlag
                    svg
                    className={styles.country_flag}
                    countryCode={getLanguageFlag(language.selectedLanguage)}
                  />
                  <span>Change course</span>
                </a>
                {FEATURE_LANGUAGE_SWITCHER_ENABLED && <GlobalLanguageSwitcher />}
                <a
                  href="https://franquias.wizard.com.br/wiz-tab"
                  target="_blank"
                >
                  <QuestionMarkCircleIcon className={styles.icon} />
                  FAQ
                </a>
                <a onClick={handleLogout}>
                  <ArrowRightStartOnRectangleIcon className={styles.icon} />
                  Logout
                </a>
              </div>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
 